import { InputNumberStyled } from './style';

interface InputNumberMapProps {
  disabled: boolean;
}

export const InputNumberMap = ({ disabled, ...restProps }: InputNumberMapProps) => (
  <InputNumberStyled disabled={disabled} {...restProps} />
);
